import {
  ApplicationCategory,
  Application,
  ApplicationProgressReportingFrequency,
  ApplicationStatus,
  ApplicationTeamType,
} from './ApplicationsList.types';
import { FC, SVGProps } from 'react';
import {
  AiIcon,
  CoinsIcon,
  CommunityIcon,
  GamingIcon,
  GlobeIcon,
  NftIcon,
  NodesIcon,
  SeedPlantIcon,
  TechToolIcon,
} from '@onbeam/icons/business';
import { BadgeProps } from '@onbeam/business-ui';

export const applicationStyleMap: Record<
  ApplicationCategory,
  {
    color: BadgeProps['color'];
    icon: FC<SVGProps<SVGSVGElement>>;
    name: string;
    bgImageUrl: string;
  }
> = {
  [ApplicationCategory.TECH]: {
    color: 'blue',
    icon: TechToolIcon,
    name: 'Tech',
    bgImageUrl: '/images/applications/tech-infra.jpg',
  },
  [ApplicationCategory.INFRA]: {
    color: 'blue',
    icon: TechToolIcon,
    name: 'Infra',
    bgImageUrl: '/images/applications/tech-infra.jpg',
  },
  [ApplicationCategory.CONTENT]: {
    color: 'red',
    icon: CommunityIcon,
    name: 'Content',
    bgImageUrl: '/images/applications/content-community.jpg',
  },
  [ApplicationCategory.COMMUNITY]: {
    color: 'red',
    icon: CommunityIcon,
    name: 'Community',
    bgImageUrl: '/images/applications/content-community.jpg',
  },
  [ApplicationCategory.RESEARCH]: {
    color: 'yellow',
    icon: NodesIcon,
    name: 'Research',
    bgImageUrl: '/images/applications/research-ecosystem.jpg',
  },
  [ApplicationCategory.ECOSYSTEM]: {
    color: 'yellow',
    icon: NodesIcon,
    name: 'Ecosystem',
    bgImageUrl: '/images/applications/research-ecosystem.jpg',
  },
  [ApplicationCategory.DEFI]: {
    color: 'green',
    icon: CoinsIcon,
    name: 'DeFi',
    bgImageUrl: '/images/applications/defi.jpg',
  },
  [ApplicationCategory.AI]: {
    color: 'green',
    icon: AiIcon,
    name: 'AI',
    bgImageUrl: '/images/applications/ai.jpg',
  },
  [ApplicationCategory.RWA]: {
    color: 'green',
    icon: GlobeIcon,
    name: 'RWA',
    bgImageUrl: '/images/applications/rwa.jpg',
  },
  [ApplicationCategory.GAMING]: {
    color: 'green',
    icon: GamingIcon,
    name: 'Gaming',
    bgImageUrl: '/images/applications/gaming.jpg',
  },
  [ApplicationCategory.NFT]: {
    color: 'green',
    icon: NftIcon,
    name: 'NFT',
    bgImageUrl: '/images/applications/nft.jpg',
  },
  [ApplicationCategory.OTHER]: {
    color: 'mono',
    icon: SeedPlantIcon,
    name: 'Other',
    bgImageUrl: '/images/applications/other.jpg',
  },
};

const dummyItem: Application = {
  id: '1',
  name: 'DeFi Yield Optimizer',
  description:
    'Building a lightweight on-chain indexer to reduce infrastructure costs and improve data accessibility for developers building on the Beam Network. Designed to support EVM compatibility and scale seamlessly as new dApps join the ecosystem.',
  applicant: 'XYZ Labs',
  categories: [ApplicationCategory.TECH, ApplicationCategory.DEFI],
  primaryCategory: ApplicationCategory.TECH,
  fundingGranted: 250_000,
  createdAt: new Date('2025-08-02'),
  teamDescription:
    'Solidity engineers + a UI dev who previously launched tools on Polygon and Arbitrum.',
  detailedBudget:
    'Development: $180,000\nSecurity audit: $50,000\nMarketing & community growth: $40,000\nInfrastructure & hosting: $30,000',
  startDate: new Date('2025-07-01'),
  endDate: new Date('2026-01-01'),
  milestones:
    '1. MVP & contracts on testnet (Sept 2025)\n2. Full audit & bug bounty (Nov 2025)\n3. Mainnet launch (Dec 2025)\n4. Community staking campaign (Jan 2026)',
  rationale:
    'Expands DeFi options on Beam, drives transaction volume, and directly integrates $BEAM staking — building long-term ecosystem value.',
  demoUrl: 'https://github.com/defibuilders/beam-yield',
  ratedAt: new Date('2025-07-01'),
  fundingRequest: 1_000_000,
  progressReportingFrequency: ApplicationProgressReportingFrequency.DAILY,
  teamType: ApplicationTeamType.ORGANIZATION,
  email: 'e@ma.il',
  onePagerUrl: 'https://google.it',
  status: ApplicationStatus.APPROVED,
};

export const applicationItems: Application[] = [
  dummyItem,
  {
    ...dummyItem,
    id: '2',
    name: 'Node Infra Booster Research',
    categories: [ApplicationCategory.RESEARCH],
    primaryCategory: ApplicationCategory.RESEARCH,
  },
  {
    ...dummyItem,
    id: '3',
    name: 'Beam Academy Videos',
    categories: [ApplicationCategory.CONTENT],
    primaryCategory: ApplicationCategory.CONTENT,
  },
  // {
  //   ...dummyItem,
  //   id: '4',
  //   title: 'Very Bad Request',
  //   categories: [ApplicationCategory.ECOSYSTEM, ApplicationCategory.NFT],
  //   primaryCategory: ApplicationCategory.NFT,
  //   status: ApplicationStatus.DENIED,
  //   fundingGranted: undefined,
  //   ratedAt: undefined,
  // },
  // {
  //   ...dummyItem,
  //   id: '5',
  //   title: 'Even worse request',
  //   categories: [ApplicationCategory.OTHER],
  //   primaryCategory: ApplicationCategory.OTHER,
  //   status: ApplicationStatus.DENIED,
  //   fundingGranted: undefined,
  //   ratedAt: undefined,
  // },
];
